import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        primary: {
            main: "#08468F",
        },
    },
    colorSchemes: {
        light: {
            palette: {
                mode: "light",
                primary: {
                    main: "#08468F",
                },
                secondary: {
                    main: "#f50057",
                },
                action: {
                    hover: "#cacaca",
                },
                background: {
                    default: "#f4f6f8",
                    paper: "#ffffff",
                },
                text: {
                    primary: "#333",
                    secondary: "#666",
                },
            },
        },
        dark: {
            palette: {
                mode: "dark",
                primary: {
                    main: "#08468F",
                },
                secondary: {
                    main: "#f50057",
                },
                action: {
                    hover: "#444444",
                },
                background: {
                    default: "#121212",
                    paper: "#1D1D1D",
                },
                text: {
                    primary: "#fff",
                    secondary: "#ccc",
                },
            },
        },
    },
});

export default theme;
